
export const circles=[
	{
	  id:1,
	  color:'#ee6c4d'
	},
	{
	  id:2,
	  color:'#8e94f2'
	},
	{
	  id:3,
	  color:'#83c5be'
	},
	{
	  id:4,
	  color:'#fec89a'
	}
  ];